// Internal
import type { BaseAddressFieldResults } from '@/store';
import { useStoreState } from '@/store';

const useShippingAddress = (): BaseAddressFieldResults => {
  const shipToBilling = useStoreState(({ form }) => form.shipToBilling);
  const billingAddress = useStoreState(({ form }) => form.billingAddress);
  const shippingAddress = useStoreState(({ form }) => form.shippingAddress);

  return shipToBilling.value ? billingAddress : shippingAddress;
};

export { useShippingAddress };
